<template>
    <div class="flex-1 max-w-6xl mx-auto flex flex-col py-6 space-y-4">
        <div class="flex flex-col bg-white p-2 rounded-lg relative">
            <h2 class="uppercase text-lg font-medium">{{ requestData.title }}</h2>
            <h4 class="uppercase text-sm text-gray-600">Content Request &middot; Active</h4>

            <div class="absolute top-0 right-0 bg-gray-900 rounded-full text-white px-3 py-1.5 text-xs mt-2 mr-2">
                LSM Aggregated Content
            </div>

            <p class="mt-4">{{ requestData.description  }}</p>
        </div>
        <div>
            <h2 class="font-medium">Submitted Content</h2>
            <div class="grid grid-cols-2 gap-4 mt-2" v-if="requestData.videos.length > 0">
                <div
                    v-for="video in requestData.videos"
                    class="bg-white rounded-md shadow-md flex flex-row p-2 relative overflow-hidden group select-none cursor-pointer"
                    :class="{'ring-2 ring-green-600': video.purchased}"
                    v-on:click="openSlideOver(video)"
                >
                    <div
                    class="flex-none flex flex-col items-center content-center w-48 relative"
                    >
                        <div
                            class="absolute top-0 left-0 mt-2 ml-2 bg-blue-500 rounded-md text-white z-20 text-xs px-1.5 py-0.5"
                        >
                            {{ video.length | timecode }}
                        </div>
                        <progressive-img
                            class="rounded-md z-0"
                            fallback="/static/image-unavailable.png"
                            :src="video.thumbnailUrl"
                        />
                        <StarRating
                            class="absolute bottom-0 left-0 mb-1 ml-2 z-20"
                            :id="video.id"
                            :rating="video.rating"
                            v-if="video.rating !== null"
                        />
                    </div>
                    <div
                    class="flex-1 flex flex-col pl-2 whitespace-nowrap overflow-ellipsis overflow-hidden relative"
                    >
                        <p class="whitespace-nowrap overflow-ellipsis overflow-hidden">{{ video.title }}</p>
                        <span v-if="!video.purchased">Price: ${{ video.price }}<br /></span>
                        {{ video.created_at | displayLocalDateTime }} <br />
                        Credit: {{ video.user.name }} / LSM <br />
                        <div class="absolute top-0 right-0" v-tippy :title="video.emgargo">
                            <i class="fa-solid fa-circle-exclamation text-red-600" v-if="video.embargo"></i>
                        </div>
                        <strong v-if="video.purchased" class="pt-2">Purchased</strong>
                    </div>
                    <div v-if="video.purchased" class="bg-green-600 uppercase font-medium absolute top-0 right-0 rounded-md text-white px-1.5 py-0.5 text-xs">
                        Purchased
                    </div>
                </div>


            </div>
            <p v-if="requestData.videos.length < 1">No content has been submitted yet. Please check back soon for updates.</p>
        </div>
    </div>
  </template>
  
  <script>
  import * as Config from "@/config";
  import { mapGetters } from "vuex";
  import StarRating from "@/components/general/StarRating";

  import moment from "moment";
  
  export default {
    name: "MediaNetworkRequest",
    data() {
      return {
        requestData: null,
      };
    },
    components: { StarRating },
    mounted() {
      this.getRequest(this.$route.params.id);
    },
    methods: {
      ...mapGetters(["getAuthorizationHeader"]),
      async getRequest(requestId) {
        let res = await this.$http.get(Config.apiPath + "/api/v2/media/requests/" + requestId)
        this.requestData = res.data;
      },
      openSlideOver(video) {
        this.$eventBus.$emit("openSlideOver", video);
        }
    },
  };
  </script>
  